// FECOA-1462 AC-1: the All Assessments table defaults to status sorted
// alphabetically ascending, so 'completed' rows surface above 'pending'.
export const DEFAULT_PARTICIPANT_SURVEY_SORT = {
  key: 'status',
  direction: 'ascending',
};

const DATE_KEYS = new Set(['date', 'completed_at']);

const getTimestamp = (value) => {
  if (!value) return null;
  const timestamp = new Date(value).getTime();
  return Number.isNaN(timestamp) ? null : timestamp;
};

export const getParticipantSurveySortValue = (survey, key) => {
  switch (key) {
    case 'date':
      return (
        survey.relevantDate ||
        survey.completed_at ||
        survey.available_at ||
        survey.date ||
        survey.start_time ||
        survey.created ||
        survey.metadata?.created ||
        null
      );
    case 'completed_at':
      return survey.completed_at || null;
    case 'survey_name':
      return survey.survey_name || survey.survey_details?.name || '';
    case 'status':
      return survey.status || '';
    case 'visitName':
      return survey.visitName || survey.visit_name || survey.visit || '';
    case 'windowId':
      return survey.object_id || survey.metadata?.window_id || survey.id || '';
    default:
      return survey[key];
  }
};

export const sortParticipantSurveyRows = (
  rows,
  sortConfig = DEFAULT_PARTICIPANT_SURVEY_SORT
) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  const key = sortConfig?.key || DEFAULT_PARTICIPANT_SURVEY_SORT.key;
  const direction = sortConfig?.direction || DEFAULT_PARTICIPANT_SURVEY_SORT.direction;
  const directionMultiplier = direction === 'ascending' ? 1 : -1;

  return [...safeRows].sort((a, b) => {
    const aValue = getParticipantSurveySortValue(a, key);
    const bValue = getParticipantSurveySortValue(b, key);
    const aEmpty = aValue === null || aValue === undefined || aValue === '';
    const bEmpty = bValue === null || bValue === undefined || bValue === '';

    if (aEmpty && bEmpty) return 0;
    if (aEmpty) return 1;
    if (bEmpty) return -1;

    if (DATE_KEYS.has(key)) {
      const aTimestamp = getTimestamp(aValue);
      const bTimestamp = getTimestamp(bValue);
      const aInvalid = aTimestamp === null;
      const bInvalid = bTimestamp === null;

      if (aInvalid && bInvalid) return 0;
      if (aInvalid) return 1;
      if (bInvalid) return -1;

      return (aTimestamp - bTimestamp) * directionMultiplier;
    }

    const comparison = String(aValue).localeCompare(String(bValue), undefined, {
      numeric: true,
      sensitivity: 'base',
    });
    return comparison * directionMultiplier;
  });
};
